if(!global["rangy"]) global["rangy"] = {};
module.exports = global["rangy"]["saveSelection"] = require("-!./rangy-selectionsaverestore.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?rangy.saveSelection!./~/rangy/lib/rangy-selectionsaverestore.js
// module id = 524
// module chunks = 6